export default "__VITE_ASSET__Ckfh4Swm__"